import React, { useEffect, useState } from "react";
import AOS from "aos";
import { useParams, useNavigate } from "react-router-dom";
import "aos/dist/aos.css";
import "../styles/ProductDetail.css";

// Embossed
import embossed1 from "../assets/111.webp";
import embossed2 from "../assets/112.webp";
import embossed3 from "../assets/113.webp";
import embossed4 from "../assets/117.webp";
import embossed5 from "../assets/118.webp";
import embossed6 from "../assets/125.webp";
import embossed7 from "../assets/131.webp";
import embossed8 from "../assets/132.webp";

// Laminate
import laminate1 from "../assets/225.webp";
import laminate2 from "../assets/226.webp";
import laminate3 from "../assets/236.webp";
import laminate4 from "../assets/449.webp";

// Luminous
import luminous1 from "../assets/454.webp";
import luminous2 from "../assets/456.webp";
import luminous3 from "../assets/460.webp";
import luminous4 from "../assets/468.webp";
import luminous5 from "../assets/479.webp";
import luminous6 from "../assets/485.webp";
import luminous7 from "../assets/495.webp";
import luminous8 from "../assets/501.webp";
import luminous9 from "../assets/503.webp";
import luminous10 from "../assets/506.webp";

// Ultra Lam
import ultra1 from "../assets/783.webp";
import ultra2 from "../assets/784.webp";
import ultra3 from "../assets/793.webp";
import ultra4 from "../assets/803.webp";
import ultra5 from "../assets/804.webp";

// Villa
import villa1 from "../assets/889.webp";
import villa2 from "../assets/892.webp";
import villa3 from "../assets/894.webp";
import villa4 from "../assets/903.webp";

// Fire Exit
import fire1 from "../assets/908.webp";
import fire2 from "../assets/911.webp";
import fire3 from "../assets/912.webp";
import fire4 from "../assets/914.webp";
import fire5 from "../assets/916.webp";

// Metal
import metal1 from "../assets/672.webp";
import metal2 from "../assets/675.webp";

// Product ID Mapping
const doorCategories = [
  {
    id: "1",
    name: "Luxury Embossed Doors",
    description: "Weather-resistant and stylish, perfect for modern homes.",
    doors: [
      embossed1,
      embossed2,
      embossed3,
      embossed4,
      embossed5,
      embossed6,
      embossed7,
      embossed8,
    ],
  },
  {
    id: "2",
    name: "Luxury Laminate Doors",
    description: "Sophisticated entry doors crafted for luxurious villas.",
    doors: [laminate1, laminate2, laminate3, laminate4],
  },
  {
    id: "3",
    name: "Luxury Luminous Doors",
    description: "Reliable emergency exit doors meeting all safety standards.",
    doors: [
      luminous1,
      luminous2,
      luminous3,
      luminous4,
      luminous5,
      luminous6,
      luminous7,
      luminous8,
      luminous9,
      luminous10,
    ],
  },
  {
    id: "4",
    name: "Luxury Metal Doors",
    description: "Elegant and secure entrances for modern apartments.",
    doors: [metal1, metal2],
  },
  {
    id: "5",
    name: "Luxury Ultra Lam Doors",
    description: "Modern statement doors with pivot functionality.",
    doors: [ultra1, ultra2, ultra3, ultra4, ultra5],
  },
  {
    id: "6",
    name: "Luxury Villa Doors",
    description: "Modern statement doors with pivot functionality.",
    doors: [villa1, villa2, villa3, villa4],
  },
  {
    id: "7",
    name: "Fire Exit Doors",
    description: "Modern statement doors with pivot functionality.",
    doors: [fire1, fire2, fire3, fire4, fire5],
  },
];

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    window.scrollTo(0, 0);

    // Find the selected product
    const product = doorCategories.find((product) => product.id === id);
    setSelectedProduct(product);
    setLoading(false);
  }, [id]);

  const handleBackToProducts = () => {
    navigate("/");
  };

  if (loading) {
    return (
      <div style={{ padding: "60px 20px", textAlign: "center" }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  if (!selectedProduct) {
    return (
      <div style={{ padding: "60px 20px", textAlign: "center" }}>
        <h2>Product not found</h2>
        <button
          onClick={handleBackToProducts}
          style={{ marginTop: "20px", padding: "10px 20px" }}
        >
          Back to Products
        </button>
      </div>
    );
  }

  return (
    <section className="product-gallery">
      <div className="category-block">
        <div className="category-header" data-aos="fade-up">
          <button onClick={handleBackToProducts} className="back-button">
            ← Back to Products
          </button>
          <h2 className="category-title">{selectedProduct.name}</h2>
          <p className="category-description">{selectedProduct.description}</p>
          <p className="product-count">
            Showing {selectedProduct.doors.length} products in this category
          </p>
        </div>

        <div className="door-grid">
          {selectedProduct.doors.map((img, i) => (
            <div className="door-card" data-aos="zoom-in" key={i}>
              <img src={img} alt={`${selectedProduct.name} ${i + 1}`} />
              <div className="door-overlay">
                <span className="door-number">#{i + 1}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductDetail;
